/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BountyResponseStatusFromJSON, BountyResponseStatusToJSON, } from './BountyResponseStatus';
import { PreviewIncidentReportResponseFromJSON, PreviewIncidentReportResponseToJSON, } from './PreviewIncidentReportResponse';
/**
 * Check if a given object implements the OwnerBountyResponseDto interface.
 */
export function instanceOfOwnerBountyResponseDto(value) {
    let isInstance = true;
    return isInstance;
}
export function OwnerBountyResponseDtoFromJSON(json) {
    return OwnerBountyResponseDtoFromJSONTyped(json, false);
}
export function OwnerBountyResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'bountyId': !exists(json, 'bountyId') ? undefined : json['bountyId'],
        'status': !exists(json, 'status') ? undefined : BountyResponseStatusFromJSON(json['status']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'decisionReason': !exists(json, 'decisionReason') ? undefined : json['decisionReason'],
        'preview': !exists(json, 'preview') ? undefined : PreviewIncidentReportResponseFromJSON(json['preview']),
    };
}
export function OwnerBountyResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'bountyId': value.bountyId,
        'status': BountyResponseStatusToJSON(value.status),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'decisionReason': value.decisionReason,
        'preview': PreviewIncidentReportResponseToJSON(value.preview),
    };
}
